@if (state === 'ready') {
  <div class="tags">
    <button class="tags__arrow-left" (click)="scrollLeft()" [disabled]="shouldDisableLeftScroll()">
      <img ngSrc="/images/arrow.png" width="14" height="10" alt="scroll left" />
    </button>
    <div class="tags__list-container" #listContainer>
      <div class="tags__list" #list>
        @for (tag of tags; let index = $index; track tag) {
          <app-chip
            [text]="tag"
            [clickable]="true"
            [active]="activeTagIndex === index"
            (selected)="onTagClick($event, index)">
          </app-chip>
        }
      </div>
    </div>
    <button class="tags__arrow-right" (click)="scrollRight()" [disabled]="shouldDisableRightScroll()">
      <img ngSrc="/images/arrow.png" width="14" height="10" alt="scroll right" />
    </button>
  </div>
} @else {
  <app-tags-skeleton></app-tags-skeleton>
}
